import React, { useState } from "react"
import Marquee from "react-marquee-slider"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"
import {Link} from "gatsby"

export const query = graphql`
  {
    allFile(filter: { relativeDirectory: { eq: "marquee" } }) {
      nodes {
        childImageSharp {
          fixed(height: 61) {
            #src
            ...GatsbyImageSharpFixed_withWebp_tracedSVG
          }
        }
      }
    }
  }
`

const Marquees = () => {
  const [speed, setSpeed] = useState(36)

  const result = useStaticQuery(query)
  const {
    allFile: { nodes: images },
  } = result
  
  return (
    <Wrapper>
      <Marquee velocity={speed}>
        {images.map((item, index) => (
          <Link 
            to="#" 
            key={index}
            onMouseEnter={() => setSpeed(0)}
            onMouseLeave={() => setSpeed(36)}
          >
          <Image           
            fixed={item.childImageSharp.fixed}
            alt=""
            className="image"
            scale={0.7}           
          />
          </Link>
        ))}
      </Marquee>
      
    </Wrapper>
  )
}

const Wrapper = styled.div`
height: 6rem;
border-top: 1px solid var(--clr-grey-9);
border-bottom: 1px solid var(--clr-grey-9);

.image {
  margin-top: 15px;
  margin-left: 57px;  
  -webkit-transition: var(--transition);
  transition: var(--transition);
  
  :hover {
  ${'' /* filter:  brightness(8) drop-shadow(6px 6px 10px var(--clr-primary-2)); */}
  transform: scale(1.1)
  }
}
`

export default Marquees
